import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";

// define a generatePDF function that accepts a tickets argument
const generatePDF = (data) => {
  var doc = new jsPDF("l", "mm", "a4");
  var d = format(new Date(), "yyyy-MM-dd");
  const tableColumn = [
    "Email",
    "First Name",
    "Last Name",
    "Phone Number",
    "Total Requests",
  ];
  // define an empty array of rows
  const tableRows = [];

  // for each report pass all its data into an array
  data.forEach((report) => {
    const paymentData = [
      report.email,
      report.firstName,
      report.lastName,
      report.phoneNumber,
      report.requestCount,

      // called date-fns to format the date on the report
    ];
    // push each tickcet's info into a row
    tableRows.push(paymentData);
  });

  // startY is basically margin-top
  doc.autoTable(tableColumn, tableRows, { startY: 20 });
  const date = Date().split(" ");
  // we use a date string to generate our filename.
  const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
  // report title. and margin-top + margin-left
  doc.text("Customer List " + d, 14, 15);
  // we define the name of our PDF file.
  doc.save(`customer_report_${d}.pdf`);
};

export default generatePDF;
